module.exports = {
        srcSet: __webpack_public_path__ + "static/media/opportunity-check-800.37b4ced2.webp"+" 800w"+","+__webpack_public_path__ + "static/media/opportunity-check-992.5db31fbf.webp"+" 992w",
        images: [{path: __webpack_public_path__ + "static/media/opportunity-check-800.37b4ced2.webp",width: 800,height: 1058},{path: __webpack_public_path__ + "static/media/opportunity-check-992.5db31fbf.webp",width: 992,height: 1312}],
        src: __webpack_public_path__ + "static/media/opportunity-check-992.5db31fbf.webp",
        toString: function(){return __webpack_public_path__ + "static/media/opportunity-check-992.5db31fbf.webp"},
        
        width: 992,
        height: 1312
      }